import { CategoryLevel } from '@/types/api'

import { isBrandCategoryMetas, isCategoryMetas, isPurePLPMetas, isTagMetas } from '@/app/(plp)/_utils/type-guards'
import { PLPBasicMetasProps, PLPPages } from '@/app/(plp)/types'

export function getGTMCategories(page: PLPPages, basicMetas: PLPBasicMetasProps): [string, string, string] {
    if (page === PLPPages.Categories || page === PLPPages.Combination) {
        let breadcrumb: CategoryLevel[] | null = null

        if (isCategoryMetas(page, basicMetas)) {
            breadcrumb = basicMetas?.breadcrumb
        } else if (isBrandCategoryMetas(page, basicMetas)) {
            breadcrumb = basicMetas?.category?.breadcrumb
        }

        switch (breadcrumb?.length) {
            case 1:
                return [breadcrumb[0].nameFa || '', '', breadcrumb[0].nameFa || '']
            case 2:
                return [breadcrumb[0].nameFa || '', breadcrumb[1].nameFa || '', breadcrumb[1].nameFa || '']
            case 3:
                return [breadcrumb[0].nameFa || '', breadcrumb[1].nameFa || '', breadcrumb[2].nameFa || '']
            default:
                return ['', '', '']
        }
    }
    if (page === PLPPages.Tags) {
        const slug = isTagMetas(page, basicMetas) ? (basicMetas?.slug ?? '') : ''

        return ['خانومی', slug, slug]
    } else {
        const slug = isPurePLPMetas(basicMetas) ? (basicMetas.nameFa ?? '') : ''
        return ['خانومی', slug, slug]
    }
}
